module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9gPYWN/tc-custom/9781035840359.jpg?1721057580385",
      "alt": "This image is the cover for the book The Aftermath: Book 2 – Those That Remain"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Aftermath: Book 2 – Those That Remain\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the aftermath of a devastating war, telepathic twin sisters guide a growing band of survivors to the sanctuary of their childhood home. But as supplies dwindle and tensions rise, they make a fateful decision to leave their rural haven for the uncertainties of the city. Embarking on a perilous journey, they aim to find rescue parties, other survivors, and crucially, sustenance. Yet, the road is fraught with unforeseen dangers that test their resilience and unity. As they draw closer to their destination, questions loom large: What new threats lie ahead? Can they secure enough food to sustain the group? And will they find a city still standing, or will their expedition prove futile? Prepare for an edge-of-your-seat adventure that explores the limits of human endurance and the bonds that tie us together in times of crisis.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jenny Walker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jenny Walker lives in Northallerton, the County Town of North Yorkshire. She has spent most of her life working in offices where, amongst other things, she achieved ISO:9001 and IIP, along with writing H&S manuals, company handbooks and HR documentation. In complete contrast, Jenny also spent several years as a poultry breeder. Jenny is now a full-time author. www.jennywalkerauthor.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0